import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import axios from 'axios';
import {
  get,
  replace,
} from 'lodash';

import MediaKitHeader from 'dyzio-shared-components/lib/components/media-kit-header';
import MediaKitBody from 'dyzio-shared-components/lib/components/media-kit-body';

import hasUserInfo from '../../hocs/has-user-info';
import hasJSONAPIClient from '../../hocs/has-jsonapi-client';
import ThemeSelector from '../../themes/theme-selector';

import {
  INFLUENCER_RESOURCE,
} from '../../utils/helpers/resources';

const pageStyle = {
  border: '1px solid #ddd',
  margin: '50px auto',
  background: '#FFF',
  padding: 20,
};

const textAlignCenter = {
  textAlign: 'center',
  height: 200,
};

class MediaKit extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      youtubeModalOpen: false,
      influencer: null,
      youtubeAPIDetails: null,
    };
  }

  componentDidMount = () => {
    const { jsonAPIClient, params: { influnecerId } } = this.props;
    // eslint-disable-next-line lodash/prefer-lodash-method
    jsonAPIClient.get(INFLUENCER_RESOURCE, influnecerId)
      .then(influencerResource => {
        const influencer = influencerResource.toJSON();
        const { influencerApiLink } = influencer;
        if (!influencerApiLink) {
          this.setState({
            isLoading: false,
            influencer,
          });
        } else {
          axios.get(influencerApiLink.url).then(response => {
            const { data } = response;
            this.setState({
              isLoading: false,
              youtubeAPIDetails: data.influencer,
              influencer,
            });
          });
        }
      });
  }

  toggleYoutubeModalState = () => {
    const { youtubeModalOpen } = this.state;
    this.setState({
      youtubeModalOpen: !youtubeModalOpen,
    });
  }

  render() {
    const {
      isLoading,
      influencer,
      youtubeAPIDetails,
      youtubeModalOpen,
    } = this.state;

    const theme = ThemeSelector.theme();
    const logo = get(theme, 'headerLogo.src', null);
    const logoFixed = logo ? replace(logo, /^\//, '') : null;

    const avatarProps = get(theme, 'mediaKit.avatarProps');
    const logoProps = get(theme, 'mediaKit.logoProps');

    return (
      <div className="page" id="media-kit">
        <div className="page-content">
          <div style={pageStyle} className="media-kit-wrapper">
            {
              isLoading &&
              <div style={textAlignCenter}>Loading...</div>
            }
            {
              !isLoading && influencer &&
              <div>
                <MediaKitHeader influencer={influencer} logo={logoFixed} avatarProps={avatarProps} logoProps={logoProps} />
                <MediaKitBody
                  influencer={influencer}
                  youtubeAPIDetails={youtubeAPIDetails}
                  youtubeModalOpen={youtubeModalOpen}
                  toggleYoutubeModalState={this.toggleYoutubeModalState}
                />
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

MediaKit.propTypes = {
  jsonAPIClient: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
};

export default compose(
  hasUserInfo,
  hasJSONAPIClient,
)(MediaKit);



/** WEBPACK FOOTER **
 ** ./src/containers/media-kit/index.js
 **/